'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _propTypes3 = require('utils/prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hint = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(Hint, _PureComponent);

  function Hint() {
    (0, _classCallCheck3.default)(this, Hint);
    return (0, _possibleConstructorReturn3.default)(this, (Hint.__proto__ || (0, _getPrototypeOf2.default)(Hint)).apply(this, arguments));
  }

  (0, _createClass3.default)(Hint, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          small = _props.small,
          onClick = _props.onClick;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)('hint', className, { small: small }), onClick: onClick },
        children
      );
    }
  }]);
  return Hint;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes3.nodes,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  small: _propTypes2.default.bool
}, _class.defaultProps = {
  onClick: _noop3.default
}, _temp);
exports.default = Hint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Hint/Hint.js
// module id = 2020
// module chunks = 1